import React from 'react';

import { getBenchmarkName, benchmarkSorter } from '../../../helpers/nameHelpers';
import * as helpers from '../portfolioHelpers';

import styled from 'styled-components';

const Td = styled.td`
@media screen{
    white-space nowrap;
}
`;

function getBenchmarkRow(benchmark, currencyType, isPortfolio = false) {
    return <tr key={`cr1_${benchmark.name}`}>
        <Td>{getBenchmarkName(benchmark.name, currencyType)}</Td>
        <td>{helpers.formatCell(benchmark.portfolioEndingValue, '$')}</td>
        <td>{helpers.formatCell(benchmark.portfolioEndingValue_BeforeFees, '$')}</td>
        <td>{helpers.formatCell(benchmark.lossDueToFees, '$')}</td>
        <td>{helpers.formatCell(benchmark.lossDueToFeesPerMonth, '$')}</td>
        <td>{!isPortfolio && helpers.formatCell(benchmark.portfolioValueAddedOverBenchmark, '$')}</td>
        <td>{!isPortfolio && helpers.formatCell(benchmark.portfolioValueAddedOverBenchmark_BeforeFees, '$')}</td>
        <td>{!isPortfolio && helpers.formatCell(benchmark.gainDueToManagement, '$')}</td>
    </tr>
}

const Table = (props) => {

    const { portfolio } = props;
    const { reportData } = portfolio;

    const currencyType = portfolio.portfolio.data.currencyType;

    return <div>
        <table style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
            <thead>
                <tr>
                    <th>Comparative Terminal Value &amp; Loss Due to Fees Table 3</th>
                    <th colSpan={4}>Ending Values &amp; Value Losses due to Fees</th>
                    <th colSpan={3}>Portfolio's Values Added over Benchmarks</th>
                </tr>
                <tr>
                    <th>Client Portfolios</th>
                    <th>After Fees</th>
                    <th>Before Fees</th>
                    <th>Total Loss due to Fees</th>
                    <th>Amortized Loss from Fees/month</th>
                    <th>After Fees</th>
                    <th>Before Fees</th>
                    <th>Amortized Added Value from Mgmt/month</th>
                </tr>
            </thead>
            <tbody>
                {getBenchmarkRow(reportData.portfolio, currencyType, true)}
                <tr>
                    <td colSpan={21} style={{ fontWeight: 'bold', paddingTop: 20 }}>Client Benchmarks for {reportData.portfolio.name}</td>
                </tr>
                {/* {reportData.benchmarks.filter(e => e.name === 'clientSpecified').map(benchmark => { return getBenchmarkRow(benchmark) })} */}
                {reportData.benchmarks.sort(benchmarkSorter).filter(e => (e.selected || (e.name === 'clientSpecified' || e.name === 'equalWeight'))).map(benchmark => { return getBenchmarkRow(benchmark, currencyType) })}
            </tbody>
        </table>
    </div>
};

export default Table;


// WEBPACK FOOTER //
// ./src/portfolio/components/ReportTables/ComparativeTerminalValueTable3.js